export default __webpack_public_path__ + "static/media/classroom.7cb4ab12.svg";